import { render, staticRenderFns } from "./lims.vue?vue&type=template&id=ea4847ac&scoped=true"
import script from "./lims.vue?vue&type=script&lang=js"
export * from "./lims.vue?vue&type=script&lang=js"
import style0 from "./lims.vue?vue&type=style&index=0&id=ea4847ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4847ac",
  null
  
)

export default component.exports